import CouponError from './CouponsError';
class InvestorCouponUsed extends CouponError {
    couponId;
    propertyId;
    constructor(couponId, propertyId, options) {
        super('Promotional coupon is already in use', options);
        this.couponId = couponId;
        this.propertyId = propertyId;
    }
}
export default InvestorCouponUsed;
